import { AxiosError } from 'axios'
import { ENDPOINT_WORKSPACE_MEMBERS } from '../config'
import AuthAxios from '@/lib/api/axios/AuthAxios'

export interface RemoveMemberResponse {
  message: string
}

/**
 * Remove a member from the workspace
 * DELETE /api/v1/e/{workspaceSlug}/members/{memberId}
 */
const removeMember = async (
  workspaceSlug: string,
  memberId: string,
): Promise<RemoveMemberResponse> => {
  try {
    const response = await AuthAxios.delete<RemoveMemberResponse>(
      `${ENDPOINT_WORKSPACE_MEMBERS}/${workspaceSlug}/members/${memberId}`
    )
    return response.data
  } catch (error) {
    if (error instanceof AxiosError && error.response?.status === 403) {
      throw new Error('You do not have permission to remove members')
    }
    throw error
  }
}

export default removeMember
